export * from './bankAccounts';
export * from './dopInfo';
export * from './attributes';
export * from './riskAssess';
export * from './svedBV';
export * from './svedVPR';
export * from './svedClient';
export * from './components';
export * from './dokReestr';
export * from './svedIOU';
export * from './svedAU';
export * from './svedTarget';
export * from './svedPredst';
export * from './dossier.component';
export * from './dossierBaseModel';
export * from './dossierPageResolver';
export * from './IDossierSub.service';
export * from './dossierBasePage.component';
export * from './dossierBase.component';
export * from './dossierStatusEnum';
export * from './dossierStatusResolver';
export * from './access';
export * from './dossierFLKResolver';
